export const buildReactionCounter = (reactions = [], userReaction, userName) => {
    try {
        const normalizedReactions = reactions.map((react) => ({
            emoji: react,
        }));

        if (!userReaction) {
            return normalizedReactions;
        }

        const myReactionIndex = normalizedReactions.findIndex((reaction) => reaction?.emoji === userReaction);
        const myReaction = { emoji: userReaction, by: userName };

        if (myReactionIndex === -1) {
            return [myReaction, ...normalizedReactions];
        }

        const nextReactionCounter = [...normalizedReactions];
        nextReactionCounter.splice(myReactionIndex, 1);
        return [myReaction, ...nextReactionCounter];
    } catch (err) {
        console.error('Error building reaction counter:', err);
        return [];
    }
};

export const promoteMyReaction = (reactionCounter = [], emoji, userName) => {
    try {
        const nextReactionCounter = [...reactionCounter];
        const currentIndex = nextReactionCounter.findIndex((reaction) => reaction?.by === userName);
        const myReaction = {
            emoji,
            by: userName,
        };

        if (currentIndex >= 0) {
            nextReactionCounter.splice(currentIndex, 1);
        }

        return [myReaction, ...nextReactionCounter];
    } catch (err) {
        console.error('Error promoting reaction:', err);
        return [];
    }
};
